import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import OkCancelModal from '@/shared/components/OkCancelModal';
import Checkbox from '@/shared/components/input/Checkbox';
const messages = defineMessages({
    RecognitionOptions: {
        id: 'RecognitionOptions',
        defaultMessage: 'RecognitionOptions',
    },
    LinkEmailsToCustomer: {
        id: 'LinkEmailsToCustomer',
        defaultMessage: 'Link emails to relations of type customer',
    },
    LinkEmailsToOther: {
        id: 'LinkEmailsToOther',
        defaultMessage: 'Link emails to relations of type other',
    },
    LinkEmailsToProspect: {
        id: 'LinkEmailsToProspect',
        defaultMessage: 'Link emails to relations of type prospect',
    },
    LinkEmailsToOwnCompany: {
        id: 'LinkEmailsToOwnCompany',
        defaultMessage: 'Link emails to relations of type own company',
    },
    AllowedSendersDescription: {
        id: 'AllowedSendersDescription',
        defaultMessage: 'By default, only attachments of e-mails sent by one of the employees to the magic-mail address will be recognized. Click the add button below to add custom e-mail senders for which document recognition should also be performed on attachments.',
    },
    EmailPlaceholder: {
        id: 'Email',
        defaultMessage: 'Email',
    },
    Add: {
        id: 'Add',
        defaultMessage: 'Add',
    },
    RemoveEmailAddress: {
        id: 'RemoveEmailAddress',
        defaultMessage: 'Remove e-mail address',
    },
});
const RecognitionOptionsModal = ({ show, onClose, onSave, magicMailAllowedAttachmentSenders, linkEmailToCrmOther, linkEmailToCrmProspect, linkEmailToCrmOwnCompany, }) => {
    const intl = useIntl();
    const [emailSenders, setEmailSenders] = useState(() => magicMailAllowedAttachmentSenders ? magicMailAllowedAttachmentSenders.split(';') : []);
    const [crmOther, setCrmOther] = useState(linkEmailToCrmOther);
    const [crmProspect, setCrmProspect] = useState(linkEmailToCrmProspect);
    const [crmOwnCompany, setCrmOwnCompany] = useState(linkEmailToCrmOwnCompany);
    const handleSave = () => {
        onSave({
            magicMailAllowedAttachmentSenders: emailSenders.length === 0 ? '' : emailSenders.join(';'),
            linkEmailToCrmOther: crmOther,
            linkEmailToCrmProspect: crmProspect,
            linkEmailToCrmOwnCompany: crmOwnCompany,
        });
    };
    const addEmail = () => {
        setEmailSenders(prev => [...prev, '']);
    };
    const removeEmail = (index) => {
        setEmailSenders(prev => prev.filter((_, i) => i !== index));
    };
    const updateEmail = (index, value) => {
        setEmailSenders(prev => prev.map((email, i) => (i === index ? value : email)));
    };
    return (_jsx(OkCancelModal, Object.assign({ title: intl.formatMessage(messages.RecognitionOptions), show: show, onClose: onClose, onSave: handleSave, disableFullScreen: true }, { children: _jsxs("div", Object.assign({ className: "form-horizontal", role: "form" }, { children: [_jsx("div", Object.assign({ className: "margin10B" }, { children: _jsx("div", Object.assign({ className: "form-group" }, { children: _jsxs("div", Object.assign({ className: "col-sm-12" }, { children: [_jsx("div", { children: _jsx(Checkbox, { value: true, disabled: true, onClick: () => { }, text: intl.formatMessage(messages.LinkEmailsToCustomer) }) }), _jsx("div", { children: _jsx(Checkbox, { value: crmOther, onClick: v => setCrmOther(v), text: intl.formatMessage(messages.LinkEmailsToOther) }) }), _jsx("div", { children: _jsx(Checkbox, { value: crmProspect, onClick: v => setCrmProspect(v), text: intl.formatMessage(messages.LinkEmailsToProspect) }) }), _jsx("div", { children: _jsx(Checkbox, { value: crmOwnCompany, onClick: v => setCrmOwnCompany(v), text: intl.formatMessage(messages.LinkEmailsToOwnCompany) }) })] })) })) })), _jsx("div", Object.assign({ className: "margin10B" }, { children: intl.formatMessage(messages.AllowedSendersDescription) })), _jsx("div", Object.assign({ className: "form-group" }, { children: _jsxs("div", Object.assign({ className: "col-sm-12" }, { children: [emailSenders.map((email, index) => (_jsxs("div", Object.assign({ className: "row margin10B" }, { children: [_jsx("div", Object.assign({ className: "col-sm-11" }, { children: _jsx("input", { type: "text", placeholder: intl.formatMessage(messages.EmailPlaceholder), className: "form-control", value: email, onChange: e => updateEmail(index, e.target.value) }) })), _jsx("div", Object.assign({ className: "col-sm-1" }, { children: _jsx("a", Object.assign({ onClick: () => removeEmail(index), style: { verticalAlign: 'sub' }, title: intl.formatMessage(messages.RemoveEmailAddress), className: "clickable" }, { children: _jsx("i", { className: "fa fa-remove" }) })) }))] }), index))), _jsx("div", { children: _jsxs("a", Object.assign({ onClick: addEmail, title: intl.formatMessage(messages.Add), className: "btn btn-default btn-xs" }, { children: [_jsx("i", { className: "fa fa-plus" }), _jsx("span", Object.assign({ className: "margin5L" }, { children: intl.formatMessage(messages.Add) }))] })) })] })) }))] })) })));
};
export default RecognitionOptionsModal;
